import React from 'react'
import { Icon } from '@iconify/react'

const ThankYouPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-indigo-50 via-white to-blue-50 p-6 text-center">
      {/* Icon */}
      <div className="bg-green-100 text-green-600 rounded-full p-4 mb-6 shadow-md">
        <Icon icon="material-symbols:check-circle" className="text-5xl" />
      </div>

      {/* Headline */}
      <h1 className="text-3xl font-bold text-gray-800 mb-2">Thank You!</h1>
      <p className="text-gray-600 mb-6">
        We really appreciate your feedback. It helps us improve our service.
      </p>

      {/* Optional CTA */}
      {/* <a
        href="/"
        className="inline-block mt-4 px-6 py-3 bg-indigo-600 text-white rounded-xl shadow hover:bg-indigo-700 transition duration-200"
      >
        Back to Home
      </a> */}
    </div>
  )
}

export default ThankYouPage
